import { useRef, useEffect } from 'react'
import { useRouter } from '../state/route.state'
import {Button} from './ui/index'
import { useAppState } from '../state/app.state'
import useTranslation from '../translation/hook'


export default function PaymentRoute({...props}){
    const t = useTranslation()
    const {state, methods} = useRouter()
    const ref = useRef()
    const {routeState} = state
    
    const iFrameStyle = {
        width: "100%",
        height: "100%",
        border: 0
    }
    
    
    const modalStyle = {
        border:0,
        height: "100%",
    flex: 1,
    width:"100%"
    }
    
    
    useEffect(() => {
        
        ref.current.focus()
    })
    
    
    return (
        <div style={{top: 70}}className="ordine-container">
            <div className="modal" style={modalStyle}>
    
                <iframe ref={ref} src={routeState.url} style={iFrameStyle}/>
                <div className="floating-back-button">
                    <Button value={t("site_pages_shop_app_back_button")} onClick={() => methods.changeRoute("app")}/>
                </div>
            </div>
        </div>
    )
}